var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKlarnaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1rem",
    height: "1rem",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.592 2v20H0V2zm11.46 0c0 4.194-1.583 8.105-4.415 11.068l-.278.283L17.702 22h-5.668l-6.893-9.4l1.779-1.332c2.858-2.14 4.535-5.378 4.637-8.924L11.562 2zM21.5 17a2.5 2.5 0 1 1 0 5a2.5 2.5 0 0 1 0-5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlarnaIcon);
export default __webpack_public_path__ + "static/media/KlarnaIcon.b11dae7606014a6d3cbbff019bd659a6.svg";
export { ForwardRef as ReactComponent };